import { render, staticRenderFns } from "./ApfQuestions.vue?vue&type=template&id=3227d872"
import script from "./ApfQuestions.vue?vue&type=script&lang=js"
export * from "./ApfQuestions.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports